import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';

export function getViewerPosition(viewer: Cesium.Viewer) {
    const { longitude, latitude, height } = viewer.camera.positionCartographic;

    return {
        center: {
            type: 'Point',
            coordinates: [Cesium.Math.toDegrees(longitude), Cesium.Math.toDegrees(latitude)],
        } satisfies PointGeometry,
        viewAngle: Cesium.Math.toDegrees(viewer.camera.pitch),
        viewRotation: Cesium.Math.toDegrees(viewer.camera.heading),
        viewHeight: height,
    };
}
